<template>
    <div class="footer__newsletter">
        <h5>Nieuwsbrief</h5>
        <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onSubmit)"
                  ref="newsletterform"
                  action="https://reveil.us14.list-manage.com/subscribe/post?u=5fae56310f5dacbd1a8a4c760&amp;id=7c4ed9fa7b"
                  class="form" id="mc-embedded-subscribe-form" method="post" name="mc-embedded-subscribe-form"
                  target="_blank">
                <input id="mce-group[408182]-408182-0" name="group[408182]" type="hidden" value="4096">
                <div class="newsletter-form" id="mc_embed_signup_scroll">
                    <validation-provider rules="required|email" v-slot="{ errors }">
                        <div class="mc-field-group newsletter-form__main">
                            <input :class="errors.length ? 'error' : ''" class="required h-full" id="mce-EMAIL"
                                   name="EMAIL" type="email" v-model="newsletterMail" value="">
                            <input @click="checkConsent" class="btn" id="mc-embedded-subscribe" name="subscribe"
                                   type="submit" value="Verzend">
                        </div>
                        <span class="error-msg" v-show="errors.length">{{errors[0]}}</span>
                    </validation-provider>
                    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div aria-hidden="true" style="position: absolute; left: -5000px;">
                        <input name="b_5fae56310f5dacbd1a8a4c760_7c4ed9fa7b" tabindex="-1" type="text" value="">
                    </div>
                    <div class="newsletter-form__disclaimer">
                        <input @change="removeConsentError" hidden="hidden" id="newsletter-disclaimer" type="checkbox"
                               v-model="newsletterConsent.val">
                        <label for="newsletter-disclaimer">Ik ga akkoord met de privacy disclaimer</label>
                    </div>
                    <span class="error-msg" v-show="newsletterConsent.showError">Gelieve akkoord te gaan met de privacy disclaimer.</span>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                newsletterMail: '',
                newsletterConsent: {
                    val: false,
                    showError: false
                }
            }
        },
        methods: {
            checkConsent() {
                if (!this.newsletterConsent.val) this.newsletterConsent.showError = true;
            },
            removeConsentError() {
                this.newsletterConsent.showError = false;
            },
            onSubmit() {
                if(this.newsletterConsent.val) this.$refs.newsletterform.submit();

            },
        },
    }
</script>